import { invalidateQuery, noddiAsync, URLKeys } from 'noddi-async';
import { NoddiCard, useAppForm } from 'noddi-ui-web';
import { z } from 'zod';
import { TanstackAccountAsyncSelect } from '../../../form/tanstack/features/Account/TanstackAccountAsyncSelect';

const validationSchema = z.object({
  user: z
    .object({ value: z.number(), label: z.string() })
    .optional()
    .nullable()
    .refine((val) => !!val, { message: 'Required' })
});

type FormValues = z.input<typeof validationSchema>;

export const AddToUserGroupForm = ({ userGroupId }: { userGroupId: number }) => {
  const { mutateAsync: createUserGroupMember } = noddiAsync.usePost({
    type: URLKeys.postUserGroupMember,
    queryConfig: {
      onSuccess: async () => {
        await invalidateQuery({ urlKey: URLKeys.getPaginatedUserGroupMembers });
      }
    }
  });

  const defaultValues: FormValues = {
    user: undefined
  };

  const form = useAppForm({
    defaultValues,
    validators: {
      onSubmit: validationSchema
    },
    onSubmit: async ({ value }) => {
      await createUserGroupMember({
        userId: value.user!.value,
        userGroupId
      });
    }
  });

  return (
    <form.AppForm>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit();
        }}
      >
        <NoddiCard title='Add members' className='md:w-100' contentClassName='flex flex-col gap-4'>
          <form.AppField name='user'>{() => <TanstackAccountAsyncSelect />}</form.AppField>
          <form.SubscribeButton label='Add' />
        </NoddiCard>
      </form>
    </form.AppForm>
  );
};
